import Request from './request'

const DeviceLog = {
  getDeviceContact(device_fid, callback) {
    Request.get('device-user-contacts/view/' + device_fid).then(callback).catch(this.bad_answer)
  },
  updateDeviceContact(device_fid, params, callback) {
    Request.post('device-user-contacts/update/' + device_fid, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
}
export default DeviceLog
